










import Vue from "vue";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src

export default Vue.extend({
  name: "home",
  methods: {
    getES6Feature (message:string) {
      if (message) {
          console.log(message);
          return ;
      }

      console.log(`I am VScode`);
    },
  },
  components: {
    HelloWorld
  },
  created () {
    //   this.getES6Feature();
  },
});
